export default "__VITE_ASSET__B7s77BAy__"